import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import ExpenseStepHeader
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingSelectRecurringExpenses/ExpenseStepHeader';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import React from 'react';
import { FDStack } from '@facet-wealth/design';
import ExpenseSummaryGroupsItemized
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingExpenseSummary/ExpenseSummaryGroupsItemized';
import useMobileLayout from 'Hooks/useMobileLayout';
import { GroupTotalValueCard } from 'Components/ComponentLibrary/Molecules/GroupTotalValueCard';

function OnboardingExpenseSummary() {
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();
  useScrollTopOnMount();
  const isMobile = useMobileLayout();

  const expenseSummaryGroups = resource.attr('expenseSummaryGroups').resources().list();

  if (!resource) return null;
  return (
    <FDStack direction={'column'} spacing={2}>
      <FDStack direction={'column'} spacing={6}>
        <ExpenseStepHeader resource={resource} />
        <FDStack direction={'column'} spacing={4}>
          <FDStack direction={isMobile ? 'column' : 'row'} spacing={isMobile ? 1 : 4} width={'100%'}>
            {
              expenseSummaryGroups.map((group) => {
                return (
                  <GroupTotalValueCard
                    key={group.id()}
                    label={group.attr('title')}
                    value={group.attr('total')}
                    icon={group.attr('icon')}
                  />
                );
              })
            }
          </FDStack>
          <ExpenseSummaryGroupsItemized groupResources={expenseSummaryGroups} />
        </FDStack>
      </FDStack>
      <SurveyStepFooter
        onSubmit={onSubmitMetaForm}
        nextButtonLabel={'Continue'}
      />
    </FDStack>
  );
}

OnboardingExpenseSummary.propTypes = {
};

OnboardingExpenseSummary.defaultProps = {
};

export default OnboardingExpenseSummary;
